export function convertDateFromGMTToLocal(gmtString) {
  const gmtDate = new Date(gmtString.replace(' ', 'T') + 'Z') // Parse as GMT

  // Add 4 hours (4 * 60 * 60 * 1000 ms)
  const abuDhabiDate = new Date(gmtDate.getTime() + 4 * 60 * 60 * 1000)

  // Format to 'YYYY-MM-DD HH:mm:ss'
  const pad = (n) => String(n).padStart(2, '0')
  const formatted = `${abuDhabiDate.getUTCFullYear()}-${pad(
    abuDhabiDate.getUTCMonth() + 1
  )}-${pad(abuDhabiDate.getUTCDate())} ${pad(abuDhabiDate.getUTCHours())}:${pad(
    abuDhabiDate.getUTCMinutes()
  )}:${pad(abuDhabiDate.getUTCSeconds())}`

  return formatted
}
